export enum LowerbarState {
    MENU,
    STATS,
    NOTIFICATIONS,
    SETTINGS
}
